import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TAGGABLE_ENTITIES } from '../../../generated/taggable-entities';
import { getEntityByTable } from '../../config/modules.config';

/**
 * Resolve a human label + icon for a `{module}.{entity}` type string.
 *
 * Lives here rather than in a page because two tag surfaces need the same
 * answer: `TagDetailPage` heads each usage group with it, and `TagPicker` names
 * the entity type its suggestions are ranked against. The labels come from the
 * entity registry's own `pluralKey`/`displayNameKey`, so tenant terminology
 * overrides apply without the caller interpolating a business term itself.
 */
export function useEntityTypeMeta() {
  const { t } = useTranslation('common');
  return useCallback(
    (entityType: string) => {
      const taggable = TAGGABLE_ENTITIES.find(
        (e) => e.entityType === entityType,
      );
      if (taggable) {
        const found = getEntityByTable(taggable.table);
        if (found) {
          return {
            plural: t(found.entity.pluralKey),
            singular: t(found.entity.displayNameKey),
            icon: found.entity.icon ?? null,
          };
        }
      }
      return { plural: entityType, singular: entityType, icon: null };
    },
    [t],
  );
}
